<template>
  <div class="col-sm-12 nopads" @click.stop="">
    <div v-if="pricingModelUpdate" class="col-sm-12 editor-form">
        <h2 class="editor-header">{{ $t('pricing_models.add') }}</h2>
        <span class="p-2">
            {{ $t('pricing_models.unit1') }}
        </span>
        <select
            v-model="pricingModelUpdate.unit1"
            class="form-select form-select-sm mb-3"
        >
            <option v-for="option in unit1Options" :key="option.value" :value="option.value">
                {{ option.text }}
            </option>
        </select>

        <span class="p-2">
          {{ $t('pricing_models.unit2') }}
        </span>
        <select
            v-model="pricingModelUpdate.unit2"
            class="form-select form-select-sm mb-3"
        >
            <option v-for="option in unit2Options" :key="option.value" :value="option.value">
                {{ option.text }}
            </option>
        </select>
      <!-- Buttons -->
      <div class="col-sm-12 button-container">
        <button
          class="btn btn-secondary form-button"
          @click.stop="$emit('close')"
        >
          {{ $t('common.cancel') }}
        </button>
        <button
          class="btn btn-success form-button"
          :disabled="loading"
          @click.stop="submit"
        >
          {{ $t('common.save') }}
        </button>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {inject} from "vue";

export default {
    name: 'PricingModelEditor',
    mixins: [restApi],
    props: {
        pricingModel: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            pricingModelUpdate: this.pricingModel,
            unit1Options: [
                { value: null, text: this.$t('pricing_models.unit_select')},
                { value: 1, text: this.$t('pricing_models.unit_km')},
                { value: 2, text: this.$t('pricing_models.unit_h')},
                { value: 3, text: this.$t('pricing_models.unit_pcs')},
                { value: 4, text: this.$t('pricing_models.unit_road_km')},
                { value: 5, text: this.$t('pricing_models.unit_kg')},
                { value: 6, text: this.$t('pricing_models.unit_tons')},
                { value: 7, text: this.$t('pricing_models.unit_square_meters')},
                { value: 8, text: this.$t('pricing_models.unit_cubic_meters')},
                { value: 9, text: this.$t('pricing_models.unit_meters')},
                { value: 10, text: this.$t('pricing_models.unit_road_meters')},
                { value: 11, text: this.$t('pricing_models.unit_material_report')},
            ],
            unit2Options: [
                { value: null, text: this.$t('pricing_models.unit_select')},
                { value: 101, text: this.$t('pricing_models.unit_duration')},
                { value: 102, text: this.$t('pricing_models.unit_reserve')},
                { value: 103, text: this.$t('pricing_models.unit_km')},
                { value: 104, text: this.$t('pricing_models.unit_area')},
                { value: 105, text: this.$t('pricing_models.unit_vehicle_plow')},
                { value: 106, text: this.$t('pricing_models.unit_vehicle_spread')},
                { value: 107, text: this.$t('pricing_models.unit_work_distance')},
                { value: 108, text: this.$t('pricing_models.unit_order')}
            ]
        }
    },

    methods: {
        setDefaultValues: function (pricingModel) {
            if (!pricingModel.unit1) {
                this.showAlert(this.$t('pricing_models.unit_missing'))
                return undefined
            }
            return pricingModel
        },

        submit: function () {
            var json = this.setDefaultValues(this.pricingModelUpdate)
            if (json !== undefined) {
                this.loading = true
                this.restAdd(this.pricingModeUrl, json, this.success, this.fail)
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
